export enum InteractionTypes {
  UP_VOTE = 'UP_VOTE',
  DOWN_VOTE = 'DOWN_VOTE',
}
